import type { ReadingPosition, SourceSummary } from "@mdbase-reader/core";

export function objectValue(value: unknown): Readonly<Record<string, unknown>> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
    ? (value as Readonly<Record<string, unknown>>)
    : {};
}

export function positionFrontmatter(position: ReadingPosition): Readonly<Record<string, unknown>> {
  if (position.kind === "pdf") {
    return { pdf: { page_index: position.pageIndex } };
  }
  if (position.kind === "epub") {
    return { epub: { locator: position.locator } };
  }
  return {
    html: {
      href: position.href,
      ...(position.progression === undefined ? {} : { progression: position.progression }),
    },
  };
}

export function matchesSearch(source: SourceSummary, search: string | undefined): boolean {
  const normalized = search?.trim().toLocaleLowerCase();
  return normalized
    ? [
        source.title,
        ...source.creators,
        ...source.tags,
        source.publication,
        source.site,
        source.published === undefined ? undefined : String(source.published),
      ]
        .filter((value): value is string => value !== undefined)
        .join("\n")
        .toLocaleLowerCase()
        .includes(normalized)
    : true;
}
